import { Input, Select } from 'antd';
import './frequencia-section.styles.scss';
import useFrequenciaSection from './use-frequencia-section.hook';
import {
  FrequenciaTipoEnum
} from '../../../../enum/lancamento-aula/frequencia-tipo.enum';
import { listAccordionFormStore } from '../../store/list-accordion-form.store';
import { useTranslation } from 'react-i18next';

interface FrequenciaSectionProps {
  idMatricula: number;
}

export default function FrequenciaSection({ idMatricula }: FrequenciaSectionProps) {
  const { TextArea } = Input;
  const {
    frequenciaOption,
  } = useFrequenciaSection();
  const {
    updateAccordionForm,
    findAccordionById
  } = listAccordionFormStore();
  const currentAccordion = findAccordionById(idMatricula);
  const { t } = useTranslation('gestao_de_aulas')

  return (
    <div className={'frequencia-section'}>
      <div className={'frequencia-section__select-input'}>
        <label className={'select-input__label'}>{t('gestao_de_aulas:presence')}</label>
        <Select
          onChange={(value: FrequenciaTipoEnum) =>
            updateAccordionForm(idMatricula, 'presenca', value)}
          className={'select-input__input'}
          options={frequenciaOption}
          disabled={currentAccordion?.disabled}
          value={currentAccordion?.form?.presenca}
          defaultValue={FrequenciaTipoEnum.PRESENTE}
        />
      </div>

      <div className={'frequencia-section__select-input'}>
        <label className={'select-input__label'}>{t('gestao_de_aulas:observation')}</label>
        <TextArea
          maxLength={255}
          disabled={currentAccordion?.disabled}
          onChange={(e) =>
          updateAccordionForm(idMatricula, 'observacao', e.target.value)}
          defaultValue={currentAccordion?.form?.observacao}
          value={currentAccordion?.form?.observacao}
          rootClassName="text-field-container__input"
          showCount
        />
      </div>
    </div>
  );
}
